// import { saveSubContractorResponses } from './api';

export const ENTITY_STATUS = {
  EDITED: 'En cours',
  NOT_EDITED: 'Nouveau',
  SUBMITTED: 'Validation en cours',
  REJECTED: 'En attente de modification',
  VALIDATED: 'Validé',
};

export const MODAL_TYPES = {
  ADD_USER: 'ADD_USER',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  DUPLICATE_PRODUCT: 'DUPLICATE_PRODUCT',
  ERROR: 'ERROR',
  NEW_PRODUCT: 'NEW_PRODUCT',
  NEXT_UNFULFILLED_SURVEY: 'NEXT_UNFULFILLED_SURVEY',
  RENAME_PRODUCT: 'RENAME_PRODUCT',
  SUBMIT_ENTITY: 'SUBMIT_ENTITY',
  SUBMIT_ENTITY_CONFIRMATION: 'SUBMIT_ENTITY_CONFIRMATION',
  SUBMIT_ENTITY_ERRORS: 'SUBMIT_ENTITY_ERRORS',
  SHARE: 'SHARE',
};

export const ENTITY_STEPS_STATUS = {
  NOT_STARTED: 'À venir',
  IN_PROGRESS: 'En cours',
  DONE: 'Validé',
};

/*export const ENTITY_STEPS: { label: string; name: string; status: string }[] = [
  {
    label: 'C’est le début de votre aventure Dipeeo !',
    name: 'step1',
    status: ENTITY_STEPS_STATUS.DONE,
  },
  {
    label: 'Décrivez nous votre activité',
    name: 'step2',
    status: ENTITY_STEPS_STATUS.DONE,
  },
  {
    label: 'Vérification de vos réponses par nos experts',
    name: 'step3',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Nous sommes officiellement votre DPO',
    name: 'step4',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Vos documents Registres/Inventaire PBD sont prêts',
    name: 'step5',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Documents Cookies/Politique/Mention RGPD sont prêts',
    name: 'step6',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Votre site est conforme !',
    name: 'step7',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Documents RH/Sécurité sont prêts',
    name: 'step8',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
  {
    label: 'Maintien opérationnel de votre structure',
    name: 'step9',
    status: ENTITY_STEPS_STATUS.NOT_STARTED,
  },
];*/

export const ENTITY_CONFORMITY_STEPS = [
  {
    label: 'Questionnaire',
    name: 'survey',
    description: "Cette étape lance l'envoi du questionnaire au client",
    status: {
      activatedAt: undefined,
      activatedBy: undefined,
    },
  },
  {
    label: 'DPO',
    name: 'dpo',
    description: 'Cette étape signifie que nous sommes maintenant le DPO du client',
    status: {
      activatedAt: undefined,
      activatedBy: undefined,
    },
  },
];

export const PROCESSOR_MONITORING_STATUS = [
  {
    label: 'Conforme',
    value: 'CONFORM',
    color: 'FF82D0A5',
  },
  {
    label: 'Audit à réaliser',
    value: 'TO_BE_AUDITED',
    color: 'FF1179A0',
  },
  {
    label: 'Document à signer',
    value: 'TO_BE_SIGNED',
    color: 'FFFFA500',
  },
  {
    label: 'Non-conforme',
    value: 'NOT_CONFORM',
    color: 'FFDD0615',
  },
];

export const BUTTON_COLORS = {
  default: '#F49D1D',
  danger: '#ff7675',
  admin: '#a29bfe',
  success: '#00b894',
  adminHover: '#7f5ce7',
  dangerHover: '#ed3f3e',
  defaultHover: '#187ead',
  successHover: '#00916e',
  disabled: '#b2bec3',
};

export const COLORS = {
  lightNavy: '#0f3e60',
  NiceBlue: '#187ead',
  AquaMarine: '#49bfbd',
  AquaBlue: '#00d2e2',
  Black: '#172a35',
  Squash: '#f49d1d',
  Red: '#dd0615',
  Green: '#82d0a5',
  LightBlue: '#c8e3f630',
  darkBlue: '#326C82',
  Grey: '#585858',
  LightGrey: '#EFF0F6',
  MediumGrey: '#C8C8C8',
  LightOrange: '#FDEFDB',
  DarkGreen: '#00b894',
  DarkGrey: 'rgba(0, 0, 0, 0.8)',
  lightGrey: 'rgba(0, 0, 0, 0.6)',
  ultraLightGrey: 'rgba(0, 0, 0, 0.2)',
  softRed: '#ff7675',
  white: '#fff',
  xlsx: '#0B9D58',
  docx: '#6991d6',
  pdf: '#ff7675',
  admin: '#a29bfe',
  darkViolet: '#666297',
  ToasterError: '#E75555',
};

export const Z_INDEX = {
  below: -1,
  base: 0,
  above: 1,
  popover: 50,
  overlay: 100,
  sidenav: 200,
  modal: 600,
  loader: 800,
  overall: 999,
};

export const COUNTER_TYPES = [
  {
    label: "Demandes d'assistance",
    description: "Nombre total de demandes d'assistance",
    amount: 0,
    id: 'assistance_requests',
  },
  {
    label: 'Droits des personnes',
    description: 'Nombre total de demande droits des personnes',
    amount: 0,
    id: 'user_rights',
  },
  {
    label: 'Violations de données',
    description: 'Nombre total de violations de données',
    amount: 0,
    id: 'data_violation',
  },
];

export const USER_ROLES = {
  ADMIN: 'superadmin',
  AGENCY: 'agency',
  CLIENT: 'user',
};

export const NEW_LABELS = {
  VERSION: 'Nouvelle version',
  ENTITY: 'Nouvelle entité',
};

export const VERSION_INIT_LABEL = 'Nouvelle version';

export const WIZARD_FIRST_CONNECTION_NO_ENTITY = [
  {
    step: 1,
    label: 'Bienvenue chez Dipeeo.',
    title: 'Bienvenue {companyName} sur votre espace RGPD Dipeeo.',
    content: "Nous sommes fiers d'être votre partenaire de confiance pour votre mise en conformité RGPD.",
    input: false,
    inputType: 'text',
    options: [],
    buttonLabel: 'DÉMARRER',
    conditions: [],
  },
  {
    step: 2,
    label: 'Pour bien commencer',
    title: 'Pour bien commencer',
    content: 'Quelle est le nom de votre première entité ?',
    input: true,
    inputType: 'text',
    options: [],
    buttonLabel: 'SUIVANT',
    conditions: [],
  },
  {
    step: 3,
    label: 'Merci !',
    title: 'Merci !',
    content:
      'Vous allez maintenant être redirigé vers votre tableau de bord. \n' +
      'Nous vous invitons à ajouter les produits associés à votre entité (application en ligne/mobile, site internet, Blog ou FAQ) et à répondre aux questionnaires associés !',
    input: false,
    inputType: 'text',
    options: [],
    buttonLabel: 'ACCEDER AU TABLEAU DE BORD',
    conditions: [],
  },
];

export const WIZARD_FIRST_CONNECTION_EXISTING_ENTITIES = [
  {
    step: 1,
    label: 'Bienvenue chez Dipeeo.',
    title: 'Bienvenue {companyName} sur votre espace RGPD Dipeeo.',
    content: "Nous sommes à nouveau fiers d'être votre partenaire de confiance pour votre mise en conformité RGPD.",
    input: false,
    inputType: 'text',
    options: [],
    buttonLabel: 'DÉMARRER',
    conditions: [],
  },
  {
    step: 2,
    label: 'Merci !',
    title: 'Merci !',
    content:
      'Vous allez maintenant être redirigé vers votre tableau de bord. \n ' +
      'Nous vous invitons à ajouter les produits associés à votre entité (application en ligne/mobile, site internet, Blog ou FAQ) et à répondre aux questionnaires associés !',
    input: false,
    inputType: 'text',
    options: [],
    buttonLabel: 'ACCEDER AU TABLEAU DE BORD',
    conditions: [],
  },
];

export const WIZARD_SUB_CONTRACTORS = [
  //   {
  //     step: 1,
  //     label: 'Bienvenue chez Dipeeo',
  //     title: 'Bienvenue chez Dipeeo !',
  //     content:
  //       'Dans le cadre de la mise en conformité RGPD de {companyName} nous devons auditer ses sous-traitants (ex : hébergeur, gestion de la paie, emailing, etc.). \n' +
  //       'Nous vous remercions par avance pour votre collaboration et votre réactivité.',
  //     input: false,
  //     inputType: 'text',
  //     options: [],
  //     buttonLabel: 'DÉMARRER',
  //     conditions: [],
  //     showNextButton: true,
  //   },
  //   {
  //     step: 2,
  //     label: 'Pour bien commencer',
  //     content: 'Pour que nous puissions traiter votre audit, pourriez-vous nous fournir les informations suivantes : ',
  //     items: [
  //       {
  //         input: true,
  //         inputType: 'text',
  //         inputLabel: "Nom de l'entreprise",
  //         name: 'companyName',
  //       },
  //       {
  //         input: true,
  //         inputType: 'text',
  //         inputLabel: 'Votre rôle',
  //         name: 'responsablePosition',
  //       },
  //       {
  //         input: true,
  //         inputType: 'text',
  //         inputLabel: 'Votre email',
  //         name: 'responsableEmail',
  //       },
  //     ],
  //     buttonLabel: 'SUIVANT',
  //     showNextButton: true,
  //   },
  //   {
  //     step: 3,
  //     label: 'Question à répondre',
  //     input: false,
  //     inputType: 'text',
  //     buttonLabel: 'SUIVANT',
  //     buttonShouldSave: true,
  //     saveFunction: saveSubContractorResponses,
  //     hasQuestion: true,
  //     showNextButton: true,
  //   },
  //   {
  //     step: 4,
  //     label: 'Merci !',
  //     title: 'Merci !',
  //     content:
  //       "Nous vous remercions d'avoir participé à notre audit RGPD. Vos réponses sont essentielles. Nous allons les traiter dans les plus brefs délais et vous recontacter si nécessaire.",
  //     input: false,
  //     inputType: 'text',
  //     options: [],
  //     conditions: [],
  //     showNextButton: false,
  //   },
];

export const NOTIFICATIONS: {
  id: string;
  label: string;
  accountOwner?: boolean;
  redirect?: string;
  sharedItem?: { type: 'entity' | 'survey' | 'step' | 'question'; id: string };
}[] = [
  {
    id: 'information_welcome',
    label:
      'Bienvenue sur la plateforme Dipeeo ! Maintenant, nous vous invitons à répondre aux questionnaires afin d’entamer votre mise en conformité !',
  },
  {
    id: 'reminder_completion',
    label:
      "Nous avons remarqué que vous n'avez pas encore répondu à certains questionnaires importants. N'oubliez pas de les compléter afin de progresser dans votre conformité.",
    redirect: 'dashboard_entity',
  },
  {
    id: 'information_entity_validation',
    label: 'Nous avons validé votre questionnaire et créé votre espace dédié sur notre drive 👏',
    accountOwner: true,
    redirect: 'google_drive',
  },
  {
    id: 'information_teams_response_done',
    label: '{collaborator_name} a répondu aux éléments qui lui ont été attribués',
    accountOwner: true,
    redirect: 'collaborators',
  },
  {
    id: 'reminder_teams_no_response',
    label: 'Des éléments partagés n’ont pas reçus de réponses',
    accountOwner: true,
    redirect: 'collaborators',
  },
  {
    id: 'information_new_shared_questions',
    label: 'Une nouvelle question vous a été attribuée !',
    accountOwner: false,
    redirect: 'shared_item',
  },
  {
    id: 'information_new_shared_surveys',
    label: 'Une catégorie de questionnaire vous a été attribuée !',
    accountOwner: false,
    redirect: 'shared_item',
  },
  {
    id: 'information_new_shared_entities',
    label: 'Une entitée vous a été attribuée !',
    accountOwner: false,
    redirect: 'shared_item',
  },
  {
    id: 'reminder_update',
    label: 'Nouvelle fonctionnalité de votre service ? Modification de vos outils ? Contactez-nous pour mettre à jour vos informations.',
    redirect: 'google_agenda',
  },
  {
    id: 'information_dpo_nomination',
    label: 'Nous sommes officiellement votre délégué à la protection des données (DPO) auprès de votre autorité de contrôle  🎉',
  },
];

export const ACCOUNT_ROLES = {
  ADMIN: 'admin',
  AccountOfficer: 'accountOfficer',
  Guest: 'guest',
  Sales: 'sales',
};

export const ADMIN_ROLES = [ACCOUNT_ROLES.ADMIN, ACCOUNT_ROLES.AccountOfficer];
